import React from 'react';
import { connect } from 'react-redux';

import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import FaqSection from 'components/no-auth/common/sections/FaqSection';
import { HeroSection } from 'components/no-auth/common/sections/HeroSection';
import { TilesSection } from 'components/no-auth/common/sections/TilesSection';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

const ApplePayPage = (props) => {
    return (
        <>
            {props.heroTitle && <HeroSection title={props.heroTitle} text={props.heroText} data={props.heroData} btnVariant="primary" noIconBtn />}
            {props.tiles && (
                <ColoredSectionContainer>
                    <TilesSection data={props.tiles} grayText />
                </ColoredSectionContainer>
            )}
            {props.tiles2 && (
                <ColoredSectionContainer bgColor="purple5">
                    <TilesSection data={props.tiles2} grayText />
                </ColoredSectionContainer>
            )}
            {props.tiles3 && (
                <ColoredSectionContainer>
                    <TilesSection data={props.tiles3} />
                </ColoredSectionContainer>
            )}
            {props.faqTitle && props.questions && <FaqSection title={props.faqTitle} questions={props.questions} />}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroText: state.extra?.strapiApi?.hero_block?.text,
        heroData: state.extra?.strapiApi?.hero_block,
        faqTitle: state.extra?.strapiApi?.faq?.title,
        questions: state.extra?.strapiApi?.faq?.questions,
        tiles: state.extra?.strapiApi?.tiles_section,
        tiles2: state.extra?.strapiApi?.tiles_section2,
        tiles3: state.extra?.strapiApi?.tiles_section3,
    };
};

export default connect(mapStateToProps)(NotAuthBasePage(ApplePayPage));
